import { useState, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { ButtonBase } from '../../../../shared/Button';
import { ActionCableContext } from '../../../../lib/actionCableContext';
import { api } from '../../../../lib/api';

export const RatingsReport = () => {
  const cable = useContext(ActionCableContext);
  const campaignId = useSelector(state => state.campaignFilter.campaignId);

  const [downloadReport, setDownloadReport] = useState({
    status: 'not-started',
    url: '',
  });

  const { t } = useTranslation('reports');

  useEffect(() => {
    const channel = cable.subscriptions.create(
      {
        channel: 'DownloadRatingReportChannel',
      },
      {
        received: reportData => {
          setDownloadReport(reportData);
        },
      },
    );

    return () => {
      channel.unsubscribe();
    };
  }, [cable.subscriptions]);

  return (
    <>
      {downloadReport.status === 'not-started' && (
        <DownloadButton
          onClick={async () => {
            const params = campaignId ? { campaign_id: campaignId } : {};
            await api.post(
              '/api/client_admin/campaign_user_feedbacks/generate_report',
              params,
            );
            setDownloadReport({ status: 'running' });
          }}
          mode="outline"
          variant="primary"
        >
          <i className="fa-regular fa-lg fa-file-lines"></i>
          {t('downloadReports.notStarted')}
        </DownloadButton>
      )}
      {downloadReport.status === 'processing' && (
        <DownloadButton disabled={true} mode="outline" variant="primary">
          <i className="fa-solid fa-lg fa-hourglass"></i>
          {t('downloadReports.processing')}
        </DownloadButton>
      )}
      {downloadReport.status === 'running' && (
        <DownloadButton mode="outline" variant="primary">
          {t('downloadReports.generating')}
        </DownloadButton>
      )}
      {downloadReport.status === 'finished' && (
        <DownloadButton
          as="a"
          target="_blank"
          href={downloadReport.url}
          mode="outline"
          variant="primary"
        >
          <i className="fa-solid fa-lg fa-download"></i>
          {t('downloadReports.finished')}
        </DownloadButton>
      )}
    </>
  );
};

const DownloadButton = styled(ButtonBase)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 15px;
  height: initial;
  margin-left: auto;
`;
